export default "__VITE_ASSET__usG3$66v__"